import React, { useState, useEffect, useMemo } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalCloseButton,
   Box,
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   useColorMode,
   IconButton,
} from '@chakra-ui/react';
import JsBarcode from 'jsbarcode';
import dotIcon from '../../../../assets/img/nfts/dot.svg';
import { MdDeleteOutline, MdOutlineEdit } from 'react-icons/md';
import AddEditForm from '../Pages/CustomerMaster/AddEditForm';
import ItemMasterForm from '../Pages/ItemMaster/ItemMasterForm';
import AddEditFormForAccount from '../Pages/AllAccountMaster/AddEditFormForAccount';
import DaybookForm from '../Pages/DaybookMaster/DaybookForm';
import DeleteDialog from '../components/DeleteDialog';
import { deleteVendor } from '../../../../redux/actions/vendor';
import { deleteCustomer, getAccount } from '../../../../redux/actions/account';
import { deleteItem } from '../../../../redux/actions/item';
import { deleteDaybook, getDaybookForPayments } from '../../../../redux/actions/daybook';
import { useDispatch, useSelector } from 'react-redux';
import { useUser, useGlobal } from 'contexts';
import { formatAmountWithLabel } from 'utils/util';
import { getInventoryDetailReport, getReportSerialWiseHistory } from '../../../../redux/actions/reports';
import {
   deleteSaleReturnInvoice,
   getSingleSalesReturnWithPrevAndNext,
} from '../../../../redux/actions/salesReturnInvoice';
import { getOneVoucher } from '../../../../redux/actions/voucher';
import {
   deletePurchaseReturnInvoice,
   getSinglePurchaseReturn,
   getSinglePurchaseReturnWithPrevAndNext,
} from '../../../../redux/actions/purchaseReturnInvoice';
import { deleteSaleInvoice, getSingleWithPrevAndNext } from '../../../../redux/actions/salesInvoice';
import { getSinglePurchaseWithPrevAndNext, deletePurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { getAccountById } from '../../../../redux/actions/account';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteRecord } from 'utils/util';
import ViewSingleCashBankData from 'components/UIcomponents/ViewSingleCashBankData';
import JournalVoucherForm from 'views/admin/journal-vouchers/Pages/JournalVoucherForm';
import { getJournalVoucher } from '../../../../redux/actions/journalVoucher';
import PaymentcaseFormEdit from '../../cash/PaymentcaseFormEdit';
import * as Yup from 'yup';
import moment from 'moment';
import { FiRefreshCcw } from 'react-icons/fi';

const ViewSingleData = ({
   isOpenSingleView,
   onClose,
   entityType,
   singleEntity,
   dynamicArray,
   ItemId,
   onDelete,
   formType,
   parentGlGroup,
   singleEntityRights,
   reCall,
}) => {
   const [activeTab, setActiveTab] = useState(
      entityType === 'customer' || entityType === 'vendor' || entityType === 'Account' ? 'payment' : 'statement',
   );
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [items, setItems] = useState([]);
   const dimension = '6*20 mm';
   const purchaseInvoice = entityType === 'purchaseinvoice';
   const [selectedRowId, setSelectedRowId] = useState(null);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const [data, setData] = useState([]);
   const businessType = localStorage.getItem('businessTypes');
   const isCustomersOrVendors = entityType === 'customer' || entityType === 'vendor' || entityType === 'Account';
   const IsItem = entityType === 'Item';
   const dispatch = useDispatch();
   const { user } = useUser();
   const Admin = user?.isAdmin;
   const [entityTypesv, setEntityTypesv] = useState([]);
   const singleEntitysv = useSelector((state) => {
      if (entityTypesv === 'receivemaster') {
         return state?.receiveInventory?.single || {};
      } else if (entityTypesv === 'issuemaster') {
         return state?.issueInventory?.single || {};
      } else if (entityTypesv === 'cash') {
         return state.voucher?.single || {};
      } else if (entityTypesv === 'bank') {
         return state.voucher?.single || {};
      } else {
         return {};
      }
   });
   const validationSchema = Yup.object().shape({
      daybookId: Yup.number().required('Daybook is required'),

      accountId: Yup.number()
         .typeError('Account must be a valid')
         .required('Account is required')
         .min(1, 'Account must be greater than 0'),

      amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),

      docNumber: Yup.string().required('Document number is required'),

      txnDate: Yup.date().required('Transaction date is required').typeError('Invalid transaction date'),

      txnType: Yup.number().required('Transaction type is required'),
   });
   const accountData = useSelector((state) => state.account.list);
   const { userGlobalSettingsData } = useGlobal();
   const shouldSendIdInDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendIdInAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const daybookTypeData = useSelector((state) => state.daybook?.listPayment || null);
   const [transactionType, setTransactionType] = useState('payment');
   const [receivedAmount, setReceivedAmount] = useState(0);
   const [totalPendingAccount, setTotalPendingAccount] = useState(0);
   const [updateFormLoading, setUpdateFormLoading] = useState(false);
   const [isOutstandingModalOpen, setIsOutstandingModalOpen] = useState(false);
   const [selectedEditAccount, setSelectedEditAccount] = useState(null);
   const [pendingVoucher, setPendingVoucher] = useState([]);
   const [errors, setErrors] = useState({});
   const [sorting, setSorting] = useState([]);
   const [formData, setFormData] = useState({
      companyId: parseInt(localStorage.getItem('companyId')),
      daybookId: null,
      docNumber: 0,
      txnType: `${transactionType === 'payment' ? 1 : 0}`,
      txnDate: new Date().toISOString().split('T')[0],
      accountId: null,
      amount: receivedAmount ? receivedAmount : 0,
      brokerId: null,
      supplierId: null,
      chequeNo: 0,
      transactionNo: null,
      bankId: null,
      bankBranchId: null,
      particulars: '',
      depositeDate: null,
      clearingDate: null,
      tdsApplicable: false,
      tdsAccountId: null,
      tdsLimit: 0,
      tdsRate: 0,
      tdsCess: 0,
      tdsSurcharge: 0,
      tdsAmount: 0,
      tdsCessAmount: 0,
      tdsSurchargeAmount: 0,
      tdsHCessAmount: 0,
      tdsInterestAmount: 0,
      tdsPenaltyAmount: 0,
      tdsOthersAmount: 0,
      notes1: '',
      notes2: '',
      notes3: '',
      notes4: '',
      notes5: '',
      userNote: '',
      taxableValue: '',
      GSTAmount: 0,
      stateOfSupply: 0,
      isRCM: false,
      GSTSubTxnType: 0,
      HSNSACId: null,
      typeofSupply: 0,
      partyBillNo: 0,
      GSTTxnType: 0,
      chequeDate: new Date().toISOString().split('T')[0],
      outAdjustments: [],
   });
   const companyId = Number(localStorage.getItem('companyId'));
   const cashRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.cash
      : null;
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isBankPageTrue, setIsBankPageTrue] = React.useState(false);
   const [isRotating, setIsRotating] = useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = React.useState(null);
   const [isOpenSingleViewcnb, setIsOpenSingleViewcnb] = React.useState(null);
   const [isOpenJV, setisOpenJV] = React.useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);
   const account = useSelector((state) => state.account.single);
   const viewDatapr = useSelector((state) => state.purchaseReturnInvoice?.purchaseReturnData);
   const viewDatasr = useSelector((state) => state.salesReturnInvoice?.saleReturnData);
   const viewDatasi = useSelector((state) => state.sales?.salesData);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.purchaseData);
   const viewDataissue = useSelector((state) => state?.issueInventory?.single);
   const viewDatareceive = useSelector((state) => state.receiveInventory?.single);
   const { viewDetail, paginate } = useMemo(() => {
      const data =
         entityTypesv === 'purchasereturn'
            ? viewDatapr?.data[0]
            : entityTypesv === 'salereturn'
            ? viewDatasr?.data[0]
            : entityTypesv === 'saleinvoice'
            ? viewDatasi?.data[0]
            : entityTypesv === 'purchaseinvoice'
            ? viewDatapi?.data[0]
            : entityTypesv === 'receiveinventory'
            ? viewDatareceive
            : entityTypesv === 'issueinventory'
            ? viewDataissue
            : null;

      const pagination =
         entityTypesv === 'purchasereturn'
            ? viewDatapr?.pagination
            : entityTypesv === 'salereturn'
            ? viewDatasr?.pagination
            : entityTypesv === 'saleinvoice'
            ? viewDatasi?.pagination
            : entityTypesv === 'purchaseinvoice'
            ? viewDatapi?.pagination
            : entityTypesv === 'receiveinventory'
            ? viewDatareceive?.pagination
            : entityTypesv === 'issueinventory'
            ? viewDataissue?.pagination
            : null;

      return { viewDetail: data, paginate: pagination };
   }, [
      viewDatapr?.data,
      viewDatapr?.pagination,
      viewDatasr?.data,
      viewDatasr?.pagination,
      viewDatasi?.data,
      viewDatasi?.pagination,
      viewDatapi?.data,
      viewDatapi?.pagination,
      viewDatareceive,
      viewDataissue,
   ]);

   useEffect(() => {
      if (isOpenSingleView) {
         if (isCustomersOrVendors) {
            setActiveTab('payment');
         } else if (IsItem) {
            setActiveTab('statement');
         }
      }
   }, [isOpenSingleView]);

   useEffect(() => {
      const handleEscKey = (event) => {
         if (event.keyCode === 27) {
            setIsOpenSingleViewinr(false);
            setIsOpenPurchaseReturnSingleView(false);
            setIsOpenSingleViewcnb(false);
         }
      };

      document.addEventListener('keydown', handleEscKey);
      return () => {
         document.removeEventListener('keydown', handleEscKey);
      };
   }, []);

   useEffect(() => {
      if (entityType === 'item' && isOpenSingleView) {
         (async () => {
            try {
               if (businessType === 'NORMAL') {
                  const financialYear = financialYears.find((a) => a.financial_year === user?.financialYear);
                  const response = await dispatch(
                     getInventoryDetailReport({
                        companyIds: user?.loginhistory?.companyId,
                        search: dynamicArray?.name || basicInfo.name,
                        itemIds: singleEntity.id,
                        fromDate: moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                        toDate: moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                     }),
                  );
                  const itemserialhistory = response[0]?.data[0]?.data;
                  setData(itemserialhistory);
               } else {
                  const response = await dispatch(
                     getReportSerialWiseHistory({
                        companyIds: user?.loginhistory?.companyId,
                        itemIds: ItemId || singleEntity.id,
                     }),
                  );
                  const itemserialhistory = response?.flatMap((data) =>
                     data.items
                        .filter((subdata) => subdata.item_name === basicInfo.name)
                        .flatMap((subdata) => subdata.transactions),
                  );

                  setData(itemserialhistory);
               }
            } catch (error) {
               // Error handling
            }
         })();
      }
   }, [isOpenSingleView]);

   const basicInfo = singleEntity?.basicInfo || {
      name: dynamicArray.find((item) => item.label === 'Name')?.value || '-',
      mobile: dynamicArray.find((item) => item.label === 'Mobile')?.value || '-',
      email: dynamicArray.find((item) => item.label === 'Email')?.value || '-',
      gstin: dynamicArray.find((item) => item.label === 'GSTIN')?.value || '-',
      hsn: dynamicArray.find((item) => item.label === 'HSN')?.value || '-',
      gst: dynamicArray.find((item) => item.label === 'GSTIN')?.value || '-',
      barcode: dynamicArray.find((item) => item.label === 'Barcode')?.value || '-',
      balancequantity1: dynamicArray.find((item) => item.label === ' Balance Oty')?.value || '-',
   };

   const isBlocked =
      singleEntity?.reason || singleEntity?.blockedAt || singleEntity?.blockedBy || singleEntity?.blockedbyname;
   const blockInfo = {
      reason: singleEntity?.reason || 'Not specified',
      blockedAt: singleEntity?.blockedAt ? new Date(singleEntity.blockedAt).toLocaleString('en-IN') : null,
      blockedBy: singleEntity?.blockedBy || null,
      blockedbyname: singleEntity?.blockedbyname || null,
   };

   const locationInfo = singleEntity?.locationInfo || {
      city: dynamicArray.find((item) => item.label === 'City')?.value || '-',
      state: dynamicArray.find((item) => item.label === 'State')?.value || '-',
      country: dynamicArray.find((item) => item.label === 'Country')?.value || '-',
      pincode: dynamicArray.find((item) => item.label === 'Pincode')?.value || '-',
      address: dynamicArray.find((item) => item.label === 'Address')?.value || '-',
   };

   const calculatePartyTotals = (transactions) => {
      let netTotal = 0;
      let retAdjTotal = 0;
      let otherAdjTotal = 0;
      let osTotal = 0;

      transactions.forEach((txn, i) => {
         const isFirstOfGroup = i === 0 || txn.id !== transactions[i - 1].id;
         if (isFirstOfGroup && txn.netAmount) netTotal += Number(txn.netAmount || 0);
         if (txn.returnadjamount) retAdjTotal += Number(txn.returnadjamount || 0);
         if (txn.otheradjamount) otherAdjTotal += Number(txn.otheradjamount || 0);
         if (isFirstOfGroup && txn.balanceamount) osTotal += Number(txn.balanceamount || 0);
      });

      return {
         netTotal,
         retAdjTotal,
         otherAdjTotal,
         osTotal,
      };
   };

   const renderInfoTab = () => {
      return (
         <div className="space-y-6  max-h-[calc(100vh-200px)] overflow-y-auto pr-2">
            {/* Header Section */}
            <div
               className={`rounded-xl overflow-hidden transition-all duration-300 ${
                  isDark ? 'bg-slate-800/50 border border-slate-700' : 'bg-white border border-gray-200 shadow-sm'
               }`}>
               <div className="flex items-center gap-5 py-3 px-6">
                  {/* Avatar */}
                  <div
                     className={`w-14 h-14 rounded-xl flex items-center justify-center ${
                        isDark ? 'bg-blue-500/10 border border-blue-500/20' : 'bg-blue-50 border border-blue-100'
                     }`}>
                     <span className={`text-2xl font-bold ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>
                        {basicInfo.name?.charAt(0)?.toUpperCase() || 'D'}
                     </span>
                  </div>

                  {/* Info */}
                  <div>
                     <h2 className={`text-xl font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                        {basicInfo.name || 'Unnamed'}
                     </h2>
                     {isCustomersOrVendors && (
                        <p className={` text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                           {basicInfo.mobile || 'No mobile provided'}
                        </p>
                     )}
                  </div>
               </div>
            </div>

            {/* Details Section */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
               {/* Basic Information */}
               <div
                  className={`rounded-xl p-6 transition-all duration-200 ${
                     isDark
                        ? 'bg-slate-800/50 border border-slate-700 hover:border-slate-600'
                        : 'bg-white border border-gray-200 hover:border-gray-300 shadow-sm'
                  }`}>
                  <h3
                     className={`text-base font-semibold mb-4 pb-3 border-b ${
                        isDark ? 'border-slate-700 text-gray-200' : 'border-gray-200 text-gray-900'
                     }`}>
                     Basic Information
                  </h3>

                  <div className="space-y-3">
                     {isCustomersOrVendors ? (
                        <>
                           {[
                              { label: 'Mobile', value: basicInfo.mobile },
                              { label: 'Email', value: basicInfo.email },
                           ].map((item, index) => (
                              <div key={index} className="flex justify-between items-center py-2">
                                 <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                    {item.label}
                                 </span>
                                 <span className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>
                                    {item.value || '-'}
                                 </span>
                              </div>
                           ))}
                        </>
                     ) : (
                        <div className="flex justify-between items-center py-2">
                           <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>HSN Code</span>
                           <span className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>
                              {basicInfo.hsn || '-'}
                           </span>
                        </div>
                     )}

                     <div className="flex justify-between items-center py-2">
                        <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>GSTIN</span>
                        <span className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>
                           {basicInfo.gstin || '-'}
                        </span>
                     </div>
                     <div className="flex justify-between items-center py-2">
                        <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Barcode</span>
                        <span className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>
                           {basicInfo.barcode || '-'}
                        </span>
                     </div>
                  </div>
               </div>

               {/* Location / Stock */}
               <div
                  className={`rounded-xl p-6 transition-all duration-200 ${
                     isDark
                        ? 'bg-slate-800/50 border border-slate-700 hover:border-slate-600'
                        : 'bg-white border border-gray-200 hover:border-gray-300 shadow-sm'
                  }`}>
                  <h3
                     className={`text-base font-semibold mb-4 pb-3 border-b ${
                        isDark ? 'border-slate-700 text-gray-200' : 'border-gray-200 text-gray-900'
                     }`}>
                     {isCustomersOrVendors ? 'Location Information' : 'Stock Information'}
                  </h3>

                  <div className="space-y-3">
                     {isCustomersOrVendors ? (
                        <>
                           {[
                              { label: 'City', value: locationInfo.city },
                              { label: 'State', value: locationInfo.state },
                              { label: 'Country', value: locationInfo.country },
                              { label: 'Pincode', value: locationInfo.pincode },
                              { label: 'Address', value: locationInfo.address },
                           ].map((item, index) => (
                              <div key={index} className="flex justify-between items-center py-2">
                                 <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                    {item.label}
                                 </span>
                                 <span
                                    className={`text-sm font-medium text-right max-w-xs ${
                                       isDark ? 'text-white' : 'text-gray-900'
                                    }`}>
                                    {item.value || '-'}
                                 </span>
                              </div>
                           ))}
                        </>
                     ) : (
                        <div className="flex justify-between items-center py-2">
                           <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                              Balance Quantity
                           </span>
                           <span className={`text-2xl font-semibold ${isDark ? 'text-green-400' : 'text-green-600'}`}>
                              {basicInfo.balancequantity1 || '0'}
                           </span>
                        </div>
                     )}
                  </div>
               </div>
            </div>
         </div>
      );
   };

   const renderPaymentTab = () => {
      return (
         <div className="space-y-4">
            <div
               className={`rounded-xl transition-all duration-200 ${
                  isDark ? 'bg-slate-800/50 border border-slate-700' : 'bg-white border border-gray-200 shadow-sm'
               } overflow-hidden`}>
               {/* Added max-height and made the container scrollable */}
               <div className="overflow-x-auto max-h-[600px] overflow-y-auto">
                  <table className="w-full">
                     <thead>
                        <tr
                           className={`${isDark ? 'bg-slate-700/50' : 'bg-gray-50'} border-b ${
                              isDark ? 'border-slate-600' : 'border-gray-200'
                           } sticky top-0 z-10`}>
                           {' '}
                           {/* Made header sticky */}
                           {[
                              'Date',
                              'V.No.',
                              'Due Days',
                              'Net Amount',
                              'Rec. Date',
                              'Rec. Book',
                              'Ret. Rec. Amt.',
                              'Oth. Rec. Amt.',
                              'OS. Amt',
                           ].map((heading, i) => (
                              <th
                                 key={i}
                                 className={`px-4 py-3 text-left text-xs font-semibold ${
                                    isDark ? 'text-gray-300' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                                 {' '}
                                 {/* Prevent text wrapping */}
                                 {heading}
                              </th>
                           ))}
                        </tr>
                     </thead>
                     <tbody className={`divide-y ${isDark ? 'divide-slate-700' : 'divide-gray-200'}`}>
                        {singleEntity?.os?.length > 0 ? (
                           singleEntity.os.map((company, cIndex) =>
                              company.data?.map((account, aIndex) => {
                                 const transactionRows = renderDataRows(account.data || []);
                                 const transactions = account.data || [];
                                 const showHeader = transactionRows && transactionRows.length > 0;
                                 const totals = calculatePartyTotals(transactions);
                                 return showHeader ? (
                                    <React.Fragment key={`company-${cIndex}-account-${aIndex}`}>
                                       {transactionRows}
                                       <tr
                                          className={`${isDark ? 'bg-blue-500/10' : 'bg-blue-50'} border-t ${
                                             isDark ? 'border-slate-600' : 'border-gray-200'
                                          }`}>
                                          <td
                                             className={`px-4 py-3 font-semibold text-sm ${
                                                isDark ? 'text-gray-200' : 'text-gray-900'
                                             } whitespace-nowrap`}
                                             colSpan={3}>
                                             Party Total:
                                          </td>
                                          <td
                                             className={`px-4 py-3 text-right font-semibold text-sm ${
                                                isDark ? 'text-white' : 'text-gray-900'
                                             } whitespace-nowrap`}>
                                             {formatAmountWithLabel(totals.netTotal)}
                                          </td>
                                          <td className="px-4 py-3" />
                                          <td className="px-4 py-3" />
                                          <td
                                             className={`px-4 py-3 text-right font-semibold text-sm ${
                                                isDark ? 'text-white' : 'text-gray-900'
                                             } whitespace-nowrap`}>
                                             {formatAmountWithLabel(totals.retAdjTotal)}
                                          </td>
                                          <td
                                             className={`px-4 py-3 text-right font-semibold text-sm ${
                                                isDark ? 'text-white' : 'text-gray-900'
                                             } whitespace-nowrap`}>
                                             {formatAmountWithLabel(totals.otherAdjTotal)}
                                          </td>
                                          <td
                                             className={`px-4 py-3 text-right font-semibold text-sm ${
                                                isDark ? 'text-white' : 'text-gray-900'
                                             } whitespace-nowrap`}>
                                             {formatAmountWithLabel(totals.osTotal)}
                                          </td>
                                       </tr>
                                    </React.Fragment>
                                 ) : null;
                              }),
                           )
                        ) : (
                           <tr>
                              <td
                                 colSpan={9}
                                 className={`px-4 py-8 text-center text-sm ${
                                    isDark ? 'text-gray-400' : 'text-gray-500'
                                 }`}>
                                 No payment information available
                              </td>
                           </tr>
                        )}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      );
   };

   const renderDataRows = (itemData) => {
      if (!itemData || !Array.isArray(itemData)) return null;

      return itemData.map((transaction, rowIndex) => {
         const previousTransaction = rowIndex > 0 ? itemData[rowIndex - 1] : null;
         const isSameId = previousTransaction && transaction.id === previousTransaction.id;

         const isOddRow = rowIndex % 2 !== 0;
         rowIndex++;

         const handledata = async (data) => {
            const storedCompanyId = localStorage.getItem('companyId');
            const companyId = parseInt(storedCompanyId);
            if (companyId === data.companyId && data.daybooktype === 20) {
               setEntityTypesv('receivemaster');
               const response = await dispatch(getReceiveInventory(data.id));
               await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
               setIsOpenSingleViewinr(true);
            }
            if (companyId === data.companyId && data.daybooktype === 19) {
               setEntityTypesv('issuemaster');
               const response = await dispatch(getIssueInventory(data.id));
               await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
               setIsOpenSingleViewinr(true);
            }
            if (companyId === data.companyId && data.daybooktype === 11) {
               setEntityTypesv('purchaseinvoice');
               await dispatch(
                  getSinglePurchaseWithPrevAndNext({
                     id: data.id,
                     page: 1,
                     limit: 1,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (companyId === data.companyId && data.daybooktype === 5) {
               setEntityTypesv('saleinvoice');
               await dispatch(
                  getSingleWithPrevAndNext({
                     id: data.id,
                     page: 1,
                     limit: 1,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (companyId === data.companyId && data.daybooktype === 12) {
               setEntityTypesv('purchasereturn');
               await dispatch(getSinglePurchaseReturn(data.id));
               await dispatch(
                  getSinglePurchaseReturnWithPrevAndNext({
                     id: data.id,
                     page: 1,
                     limit: 1,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (companyId === data.companyId && data.daybooktype === 6) {
               setEntityTypesv('salereturn');
               await dispatch(
                  getSingleSalesReturnWithPrevAndNext({
                     id: data.id,
                     page: 1,
                     limit: 1,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (companyId === data.companyId && data.daybooktype === 13) {
               setEntityTypesv('cash');
               setIsBankPageTrue(false);
               await dispatch(getOneVoucher(data.id));
               setIsOpenSingleViewcnb(true);
            }
            if (companyId === data.companyId && data.daybooktype === 14) {
               setEntityTypesv('bank');
               setIsBankPageTrue(true);
               await dispatch(getOneVoucher(data.docid));
               setIsOpenSingleViewcnb(true);
            }
         };

         return (
            <tr
               key={`row-${transaction.id || rowIndex}`}
               className={`
                  ${isOddRow ? (isDark ? 'bg-gray-700/30' : 'bg-gray-50/50') : 'transparent'}
                  ${isDark ? 'hover:bg-blue-800/30' : 'hover:bg-blue-50'}
                  transition-all duration-200 ease-in-out
                  cursor-pointer
                  border-b ${isDark ? 'border-gray-700' : 'border-gray-200'}
               `}
               onClick={() => handledata(transaction)}>
               <td className="px-4 py-3 text-sm font-medium whitespace-nowrap">
                  {!isSameId && transaction.txndate ? new Date(transaction.txndate).toLocaleDateString('en-IN') : '-'}
               </td>
               <td className="px-4 py-3 text-sm font-medium">{!isSameId ? transaction.docnumber : '-'}</td>
               <td className="px-4 py-3 text-sm text-right">{!isSameId ? transaction.dueDays : '-'}</td>
               <td className="px-4 py-3 text-sm text-right font-semibold">
                  {!isSameId && transaction.netAmount
                     ? Number(transaction.netAmount).toLocaleString('en-IN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                       })
                     : '-'}
               </td>
               <td className="px-4 py-3 text-sm text-right">
                  {transaction.adjtxndate ? new Date(transaction.adjtxndate).toLocaleDateString('en-IN') : '-'}
               </td>
               <td className="px-4 py-3 text-sm text-right">{transaction.adjdaybookname || '-'}</td>
               <td className="px-4 py-3 text-sm text-right font-semibold">
                  {transaction.returnadjamount
                     ? Number(transaction.returnadjamount).toLocaleString('en-IN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                       })
                     : '00.00'}
               </td>
               <td className="px-4 py-3 text-sm text-right font-semibold">
                  {transaction.otheradjamount
                     ? Number(transaction.otheradjamount).toLocaleString('en-IN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                       })
                     : '00.00'}
               </td>
               <td className="px-4 py-3 text-sm text-right font-bold">
                  {!isSameId && transaction.balanceamount
                     ? Number(transaction.balanceamount).toLocaleString('en-IN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                       })
                     : '-'}
               </td>
            </tr>
         );
      });
   };

   const renderStatementTabForItem = () => {
      const formatDate = (dateStr) => {
         const date = new Date(dateStr);
         const day = String(date.getDate()).padStart(2, '0');
         const month = String(date.getMonth() + 1).padStart(2, '0');
         const year = date.getFullYear();
         return `${day}/${month}/${year}`;
      };

      const totals = data?.reduce(
         (sum, entry) => sum + (parseFloat(businessType === 'NORMAL' ? entry.bal1 : entry.doc_net_amount) || 0),
         0,
      );

      const handledata = async (data) => {
         if (data.daybook_type === 20) {
            setEntityTypesv('receiveinventory');
            const response = await dispatch(getReceiveInventory(data.doc_id));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybook_type === 19) {
            setEntityTypesv('issueinventory');
            const response = await dispatch(getIssueInventory(data.doc_id));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybook_type === 11) {
            setEntityTypesv('purchaseinvoice');
            await dispatch(
               getSinglePurchaseWithPrevAndNext({
                  id: data.doc_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybook_type === 5) {
            setEntityTypesv('saleinvoice');
            await dispatch(
               getSingleWithPrevAndNext({
                  id: data.doc_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybook_type === 12) {
            setEntityTypesv('purchasereturn');
            await dispatch(getSinglePurchaseReturn(data.doc_id));
            await dispatch(
               getSinglePurchaseReturnWithPrevAndNext({
                  id: data.doc_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybook_type === 6) {
            setEntityTypesv('salereturn');
            await dispatch(
               getSingleSalesReturnWithPrevAndNext({
                  id: data.doc_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybook_type === 13) {
            setEntityTypesv('cash');
            setIsBankPageTrue(false);
            await dispatch(getOneVoucher(data.doc_id));
            setIsOpenSingleViewcnb(true);
         }
         if (data.daybook_type === 14) {
            setEntityTypesv('bank');
            setIsBankPageTrue(true);
            await dispatch(getOneVoucher(data.doc_id));
            setIsOpenSingleViewcnb(true);
         }
         if (data.daybook_type === 18) {
            setEntityTypesv('JV');
            const response = await dispatch(
               getJournalVoucher({ docNumber: data.docnumber, companyId: user?.loginhistory?.companyId }),
            );
            setCurrentRow(response[0]);
            setisOpenJV(true);
            setIsEditMode(true);
         }
      };

      return (
         <div
            className={`rounded-xl border ${
               isDark ? 'border-gray-700 bg-gray-800/50' : 'border-gray-200 bg-white shadow-sm'
            } overflow-hidden`}>
            <div className="overflow-x-auto">
               <table className="w-full">
                  <thead>
                     <tr
                        className={`${isDark ? 'bg-gray-700' : 'bg-gray-50'} border-b ${
                           isDark ? 'border-gray-600' : 'border-gray-200'
                        }`}>
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider">Date</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider">Doc#</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider">Daybook</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider">Account</th>
                        {businessType !== 'NORMAL' && (
                           <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider">
                              Serial No
                           </th>
                        )}
                        <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wider">
                           Balance (₹)
                        </th>
                     </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                     {data?.length > 0 ? (
                        <>
                           {data.map((transaction, index) => {
                              const isOddRow = index % 2 !== 0;

                              return (
                                 <tr
                                    key={index}
                                    className={`
                                       ${isOddRow ? (isDark ? 'bg-gray-700/30' : 'bg-gray-50/50') : 'transparent'}
                                       ${isDark ? 'hover:bg-blue-800/20' : 'hover:bg-blue-50'}
                                       transition-colors duration-150
                                       cursor-pointer
                                    `}
                                    onClick={() => handledata(transaction)}>
                                    <td className="px-4 py-3 text-sm font-medium whitespace-nowrap">
                                       {businessType === 'NORMAL'
                                          ? formatDate(transaction?.transactionAt)
                                          : formatDate(transaction?.transaction_at)}
                                    </td>
                                    <td className="px-4 py-3 text-sm font-medium">
                                       {businessType === 'NORMAL' ? transaction?.docno : transaction?.doc_no || '-'}
                                    </td>
                                    <td className="px-4 py-3 text-sm">
                                       {businessType === 'NORMAL'
                                          ? transaction?.daybookName
                                          : transaction?.daybook_name || '-'}
                                    </td>
                                    <td className="px-4 py-3 text-sm">
                                       {businessType === 'NORMAL'
                                          ? transaction?.accountName
                                          : transaction?.account_name || '-'}
                                    </td>
                                    {businessType !== 'NORMAL' && (
                                       <td className="px-4 py-3 text-sm font-medium">
                                          {transaction?.serial_no || '-'}
                                       </td>
                                    )}
                                    <td className="px-4 py-3 text-sm text-right font-semibold">
                                       {businessType === 'NORMAL'
                                          ? formatAmountWithLabel(transaction?.bal1)
                                          : formatAmountWithLabel(transaction?.doc_net_amount)}
                                    </td>
                                 </tr>
                              );
                           })}

                           <tr
                              className={`${isDark ? 'bg-gray-700' : 'bg-gray-100'} border-t ${
                                 isDark ? 'border-gray-600' : 'border-gray-200'
                              }`}>
                              <td
                                 colSpan={businessType === 'NORMAL' ? 4 : 5}
                                 className="px-4 py-3 text-right font-bold text-sm">
                                 Total
                              </td>
                              <td className="px-4 py-3 text-right font-bold text-sm">
                                 {formatAmountWithLabel(totals)}
                              </td>
                           </tr>
                        </>
                     ) : (
                        <tr>
                           <td colSpan={8} className="px-4 py-8 text-center text-gray-500 dark:text-gray-400">
                              No statement information available
                           </td>
                        </tr>
                     )}
                  </tbody>
               </table>
            </div>
         </div>
      );
   };

   const handleViewSingleData = async (id) => {
      await dispatch(getReceiveInventory(id));
      setIsOpenSingleViewinr(true);
   };

   const handleSalesSingleDataViewClose = () => {
      setIsOpenSingleViewinr();
   };

   const deletePurchaseReturn = () => {
      if (entityTypesv === 'purchasereturn') {
         deleteRecord(
            viewDetail?.id,
            deletePurchaseReturnInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
            handleRefreshData,
         );
      }
      if (entityTypesv === 'salereturn') {
         deleteRecord(
            viewDetail?.id,
            deleteSaleReturnInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
            handleRefreshData,
         );
      }
      if (entityTypesv === 'saleinvoice') {
         deleteRecord(
            viewDetail?.id,
            deleteSaleInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
            handleRefreshData,
         );
      }
      if (entityTypesv === 'purchaseinvoice') {
         deleteRecord(
            viewDetail?.id,
            deletePurchaseInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
            handleRefreshData,
         );
      }
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => {
      setIsOpenPurchaseReturnSingleView();
   };

   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   const handleSave = async () => {
      console.log('jv save');
   };

   const renderStatementTab = () => {
      const singleAccount = singleEntity?.ledger?.[0]?.accounts?.[0];
      const formatDate = (dateStr) => {
         const date = new Date(dateStr);
         const day = String(date.getDate()).padStart(2, '0');
         const month = String(date.getMonth() + 1).padStart(2, '0');
         const year = date.getFullYear();
         return `${day}/${month}/${year}`;
      };

      const totals = singleAccount?.data?.reduce(
         (acc, transaction) => {
            const amount = Number(transaction.amount) || 0;
            const bal = Number(transaction.bal) || 0;
            if (amount < 0) acc.totalDebit += Math.abs(amount);
            if (amount > 0) acc.totalCredit += amount;
            acc.finalBalance = bal;
            return acc;
         },
         { totalDebit: 0, totalCredit: 0, finalBalance: 0 },
      );

      const handledata = async (data) => {
         if (data.daybooktype === 20) {
            setEntityTypesv('receivemaster');
            const response = await dispatch(getReceiveInventory(data.docid));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenSingleViewinr(true);
         }
         if (data.daybooktype === 19) {
            setEntityTypesv('issuemaster');
            const response = await dispatch(getIssueInventory(data.docid));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenSingleViewinr(true);
         }
         if (data.daybooktype === 11) {
            setEntityTypesv('purchaseinvoice');
            await dispatch(
               getSinglePurchaseWithPrevAndNext({
                  id: data.docid,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 5) {
            setEntityTypesv('saleinvoice');
            await dispatch(
               getSingleWithPrevAndNext({
                  id: data.docid,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 12) {
            setEntityTypesv('purchasereturn');
            await dispatch(getSinglePurchaseReturn(data.docid));
            await dispatch(
               getSinglePurchaseReturnWithPrevAndNext({
                  id: data.docid,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 6) {
            setEntityTypesv('salereturn');
            await dispatch(
               getSingleSalesReturnWithPrevAndNext({
                  id: data.docid,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 13) {
            setEntityTypesv('cash');
            setIsBankPageTrue(false);
            await dispatch(getOneVoucher(data.docid));
            setIsOpenSingleViewcnb(true);
         }
         if (data.daybooktype === 14) {
            setEntityTypesv('bank');
            setIsBankPageTrue(true);
            await dispatch(getOneVoucher(data.docid));
            setIsOpenSingleViewcnb(true);
         }
         if (data.daybooktype === 18) {
            setEntityTypesv('JV');
            const response = await dispatch(
               getJournalVoucher({ docNumber: data.docnumber, companyId: user?.loginhistory?.companyId }),
            );
            setCurrentRow(response[0]);
            setisOpenJV(true);
            setIsEditMode(true);
         }
      };

      return (
         <div
            className={`rounded-xl border ${
               isDark ? 'border-gray-700 bg-gray-800/50' : 'border-gray-200 bg-white shadow-sm'
            } overflow-hidden`}>
            {/* Added max-height and vertical scrolling */}
            <div className="overflow-x-auto max-h-[600px] overflow-y-auto">
               <table className="w-full">
                  <thead>
                     <tr
                        className={`${isDark ? 'bg-gray-700' : 'bg-gray-50'} border-b ${
                           isDark ? 'border-gray-600' : 'border-gray-200'
                        } sticky top-0 z-10`}>
                        {' '}
                        {/* Made header sticky */}
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
                           Date
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
                           Doc#
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
                           Daybook
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
                           ContraAccount
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
                           Particulars
                        </th>
                        <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
                           Debit (₹)
                        </th>
                        <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
                           Credit (₹)
                        </th>
                        <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
                           Balance (₹)
                        </th>
                     </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                     {singleAccount?.data?.length > 0 ? (
                        <>
                           {/* Opening Balance Row */}
                           <tr
                              className={`${isDark ? 'bg-blue-900/20' : 'bg-blue-50'} border-b ${
                                 isDark ? 'border-gray-600' : 'border-gray-200'
                              }`}>
                              <td className="px-4 py-3 text-right font-bold text-sm whitespace-nowrap">
                                 Opening Balance
                              </td>
                              <td className="px-4 py-3 text-right font-bold text-sm whitespace-nowrap">
                                 {formatAmountWithLabel(singleAccount?.openingBalance)}
                              </td>
                              <td colSpan={3} className="px-4 py-3 text-right font-bold text-sm whitespace-nowrap">
                                 Total
                              </td>
                              <td className="px-4 py-3 text-right font-bold text-sm whitespace-nowrap">
                                 {formatAmountWithLabel(-totals.totalDebit)}
                              </td>
                              <td className="px-4 py-3 text-right font-bold text-sm whitespace-nowrap">
                                 {formatAmountWithLabel(totals.totalCredit)}
                              </td>
                              <td className="px-4 py-3 text-right font-bold text-sm whitespace-nowrap">
                                 {formatAmountWithLabel(totals.finalBalance)}
                              </td>
                           </tr>
                           {singleAccount.data
                              .slice()
                              .reverse()
                              .map((transaction, index) => {
                                 const isOddRow = index % 2 !== 0;

                                 return (
                                    <tr
                                       key={index}
                                       className={`
                                    ${isOddRow ? (isDark ? 'bg-gray-700/30' : 'bg-gray-50/50') : 'transparent'}
                                    ${isDark ? 'hover:bg-blue-800/20' : 'hover:bg-blue-50'}
                                    transition-colors duration-150
                                    cursor-pointer
                                 `}
                                       onClick={() => handledata(transaction)}>
                                       <td className="px-4 py-3 text-sm font-medium whitespace-nowrap">
                                          {formatDate(transaction.date)}
                                       </td>
                                       <td className="px-4 py-3 text-sm font-medium whitespace-nowrap">
                                          {transaction.docnumber || '-'}
                                       </td>
                                       <td className="px-4 py-3 text-sm whitespace-nowrap">
                                          {transaction.daybookname || '-'}
                                       </td>
                                       <td className="px-4 py-3 text-sm whitespace-nowrap">
                                          {transaction.daybookaccountname || '-'}
                                       </td>
                                       <td className="px-4 py-3 text-sm whitespace-nowrap">
                                          {transaction.particulars || '-'}
                                       </td>
                                       <td className="px-4 py-3 text-sm text-right font-semibold whitespace-nowrap">
                                          {transaction.amount < 0 ? formatAmountWithLabel(transaction.amount) : '-'}
                                       </td>
                                       <td className="px-4 py-3 text-sm text-right font-semibold whitespace-nowrap">
                                          {transaction.amount > 0 ? formatAmountWithLabel(transaction.amount) : '-'}
                                       </td>
                                       <td className="px-4 py-3 text-sm text-right font-bold whitespace-nowrap">
                                          {formatAmountWithLabel(transaction.bal)}
                                          <span
                                             className={`ml-1 text-xs ${
                                                transaction.bal > 0 ? 'text-red-500' : 'text-green-500'
                                             }`}>
                                             {transaction.bal > 0 ? 'DB' : 'CR'}
                                          </span>
                                       </td>
                                    </tr>
                                 );
                              })}
                        </>
                     ) : (
                        <tr>
                           <td colSpan={8} className="px-4 py-8 text-center text-gray-500 dark:text-gray-400">
                              No statement information available
                           </td>
                        </tr>
                     )}
                  </tbody>
               </table>
            </div>
         </div>
      );
   };

   const [isOpen, setIsOpen] = useState(false);
   const [isEditMode, setIsEditMode] = useState(false);
   const [currentRow, setCurrentRow] = useState(null);

   const handleEditClick = (rowData) => {
      setIsEditMode(true);
      setCurrentRow(rowData);
      setIsOpen(true);
   };

   const handleClose = (rowData) => {
      setIsOpen(false);
   };
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setDeleteDialogOpen(true);
   };
   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            if (formType === 'Vendor') {
               await dispatch(deleteVendor(selectedRowId));
            } else if (formType === 'Customer') {
               await dispatch(deleteCustomer(selectedRowId));
            } else if (formType === 'Item') {
               await dispatch(deleteItem(selectedRowId));
            } else if (formType === 'daybook') {
               await dispatch(deleteDaybook(selectedRowId));
            } else if (formType === 'Account') {
               await dispatch(deleteCustomer(selectedRowId));
            }
            setDeleteDialogOpen(false);
            onClose(true);
         } catch (err) {
            console.error('Failed to delete series:', err);
         }
      }
   };

   const startEditing = async (id, rowData) => {
      await dispatch(
         getDaybookForPayments({
            type: isBankPageTrue ? 14 : 13,
            companyId: user?.loginhistory?.companyId,
            ...(shouldSendIdInDaybook && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      await dispatch(
         getAccount({
            compId: user?.loginhistory?.companyId,
            status: true,
            ...(shouldSendIdInAccount && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      const selectAcc = accountData.filter((acc) => acc.id === rowData.accountId);
      setSelectedEditAccount(selectAcc[0]);
      setFormData((prev) => ({
         ...prev,
         id,
         ...rowData,
      }));
      setIsOutstandingModalOpen(true);
      setUpdateFormLoading(true);
   };

   const handleClearData = () => {
      setPendingVoucher([]);
      setFormData({
         companyId: parseInt(localStorage.getItem('companyId')),
         txnDate: new Date().toISOString().split('T')[0],
         daybookId: daybookTypeData?.length === 1 ? daybookTypeData[0].id : '',
         docNumber: 0,
         txnType: `${transactionType === 'payment' ? 1 : 0}`,
         accountId: null,
         amount: receivedAmount,
         brokerId: null,
         supplierId: 0,
         chequeNo: 0,
         transactionNo: 0,
         bankId: 0,
         bankBranchId: 0,
         particulars: '',
         depositeDate: '',
         clearingDate: '',
         tdsApplicable: false,
         tdsAccountId: 0,
         tdsLimit: 0,
         tdsRate: 0,
         tdsCess: 0,
         tdsSurcharge: 0,
         tdsAmount: 0,
         tdsCessAmount: 0,
         tdsSurchargeAmount: 0,
         tdsHCessAmount: 0,
         tdsInterestAmount: 0,
         tdsPenaltyAmount: 0,
         tdsOthersAmount: 0,
         notes1: '',
         notes2: '',
         notes3: '',
         notes4: '',
         notes5: '',
         userNote: '',
         taxableValue: '',
         GSTAmount: 0,
         stateOfSupply: 0,
         isRCM: false,
         GSTSubTxnType: 0,
         HSNSACId: 0,
         typeofSupply: 0,
         partyBillNo: 0,
         GSTTxnType: 0,
         outAdjustments: [],
      });
      setReceivedAmount(0);
      setTotalPendingAccount(0);
   };

   const handleRefreshData = async () => {
      setIsRotating(!isRotating);
      if (entityType === 'item') {
         onClose();
         setData([]);
      }
      reCall && reCall(singleEntity?.id);
   };

   return (
      <>
         <Modal
            isOpen={isOpenSingleView}
            onClose={() => {
               onClose();
               setData([]);
            }}
            size="6xl"
            overflowY="hidden">
            <ModalOverlay className="backdrop-blur-sm" />
            <ModalContent
               className={`
         ${isDark ? 'bg-slate-900 border border-slate-700' : 'bg-white border border-gray-200'} 
         rounded-xl shadow-2xl
      `}
               mx="15px">
               <ModalHeader className={`px-6 py-4 border-b ${isDark ? 'border-slate-700' : 'border-gray-200'}`}>
                  <div className="flex items-center justify-between">
                     <div className="flex items-center space-x-3">
                        {/* Blue indicator line */}
                        <div
                           className={`w-1 h-6 rounded-full ${
                              isBlocked
                                 ? isDark
                                    ? 'bg-red-500'
                                    : 'bg-red-600'
                                 : isDark
                                 ? 'bg-blue-500'
                                 : 'bg-blue-600'
                           }`}></div>

                        {/* Title with block indicator */}
                        <div className="flex items-center gap-3">
                           <h2 className={`text-xl font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                              {dynamicArray?.name || basicInfo.name || 'Details'}
                           </h2>

                           {/* Blocked Badge - Always visible in header */}
                           {isBlocked && (
                              <div className="flex items-center gap-2">
                                 <span
                                    className={`
                     px-3 py-1 text-xs font-semibold rounded-full flex items-center gap-1.5
                     ${
                        isDark
                           ? 'bg-red-900/30 text-red-300 border border-red-700'
                           : 'bg-red-100 text-red-700 border border-red-200'
                     }
                  `}>
                                    <svg
                                       className="w-3 h-3"
                                       fill="currentColor"
                                       viewBox="0 0 20 20"
                                       xmlns="http://www.w3.org/2000/svg">
                                       <path
                                          fillRule="evenodd"
                                          d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
                                          clipRule="evenodd"
                                       />
                                    </svg>
                                    BLOCKED
                                 </span>

                                 {/* Quick info tooltip/hover text */}
                                 <div className={`text-xs ${isDark ? 'text-red-400' : 'text-red-600'}`}>
                                    <div>Reason: {blockInfo.reason}</div>
                                 </div>
                              </div>
                           )}
                        </div>
                     </div>

                     {/* Actions section */}
                     <div className="flex items-center space-x-2 mr-5">
                        {/* Refresh button */}
                        <IconButton
                           icon={
                              <Box
                                 as={FiRefreshCcw}
                                 transform={isRotating ? 'rotate(-360deg)' : 'rotate(0deg)'}
                                 transition="transform 1s ease"
                              />
                           }
                           aria-label="Refresh"
                           variant="ghost"
                           size="lg"
                           _hover={{ bg: 'whiteAlpha.500' }}
                           borderRadius="lg"
                           onClick={handleRefreshData}
                        />

                        {/* Edit/Delete Menu - Conditionally disable if blocked */}
                        {(Admin || singleEntityRights?.edit || singleEntityRights?.deleteRole) && !user.isExpired && (
                           <Menu>
                              <MenuButton
                                 as={Box}
                                 cursor={isBlocked ? 'not-allowed' : 'pointer'}
                                 className={`
                     p-2 rounded-lg transition-all duration-200 mr-5
                     ${
                        isDark
                           ? isBlocked
                              ? 'opacity-50 cursor-not-allowed text-gray-500'
                              : 'hover:bg-slate-800 text-gray-300'
                           : isBlocked
                           ? 'opacity-50 cursor-not-allowed text-gray-400'
                           : 'hover:bg-gray-100 text-gray-600'
                     }
                  `}
                                 title={isBlocked ? 'Account is blocked. Cannot edit/delete.' : 'menu'}
                                 disabled={isBlocked}>
                                 <img src={dotIcon} alt="Menu" width={23} />
                              </MenuButton>

                              {!isBlocked && (
                                 <MenuList
                                    className={`
                        ${isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-gray-200'}
                        shadow-xl rounded-xl p-2
                     `}>
                                    {(Admin || singleEntityRights?.edit) && (
                                       <MenuItem
                                          onClick={handleEditClick}
                                          className={`
                              flex items-center space-x-3 px-3 py-2 rounded-lg
                              ${isDark ? 'hover:bg-slate-700 text-gray-200' : 'hover:bg-blue-50 text-gray-700'}
                              transition-colors duration-200
                           `}>
                                          <MdOutlineEdit
                                             size={20}
                                             className={isDark ? 'text-blue-400' : 'text-blue-600'}
                                          />
                                          <span className="font-medium">Edit</span>
                                       </MenuItem>
                                    )}

                                    {(Admin || singleEntityRights?.deleteRole) && (
                                       <MenuItem
                                          onClick={() => handleDeleteClick(singleEntity.id)}
                                          className={`
                              flex items-center space-x-3 px-3 py-2 rounded-lg
                              ${isDark ? 'hover:bg-slate-700 text-red-400' : 'hover:bg-red-50 text-red-600'}
                              transition-colors duration-200
                           `}>
                                          <MdDeleteOutline size={20} />
                                          <span className="font-medium">Delete</span>
                                       </MenuItem>
                                    )}
                                 </MenuList>
                              )}
                           </Menu>
                        )}

                        {/* Close button */}
                        <ModalCloseButton
                           className={`
               relative top-0 right-0 w-8 h-8 rounded-lg
               ${isDark ? 'text-gray-400 hover:bg-slate-800' : 'text-gray-500 hover:bg-gray-100'}
               transition-colors duration-200
            `}
                        />
                     </div>
                  </div>

                  {/* Additional blocked info banner */}
                  {isBlocked && (
                     <div
                        className={`
         mt-3 px-4 py-2.5 rounded-lg border flex items-center justify-between
         ${isDark ? 'bg-red-900/20 border-red-700 text-red-300' : 'bg-red-50 border-red-200 text-red-700'}
      `}>
                        <div className="flex items-center gap-4">
                           <div className="flex items-center gap-2">
                              <svg
                                 className="w-4 h-4"
                                 fill="currentColor"
                                 viewBox="0 0 20 20"
                                 xmlns="http://www.w3.org/2000/svg">
                                 <path
                                    fillRule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                    clipRule="evenodd"
                                 />
                              </svg>
                              <span className="font-medium">This account is blocked</span>
                           </div>

                           <div className="text-sm flex items-center gap-3">
                              <span>
                                 <span className="opacity-80">Reason : </span>
                                 <span className="font-medium ml-1">{blockInfo.reason}</span>
                              </span>

                              <span className="h-4 w-px bg-current opacity-30"></span>

                              <span>
                                 <span className="opacity-80">Blocked on : </span>
                                 <span className="font-medium ml-1">{blockInfo.blockedAt}</span>
                              </span>

                              <span className="h-4 w-px bg-current opacity-30"></span>

                              <span>
                                 <span className="opacity-80">Blocked By : </span>
                                 <span className="font-medium ml-1">{blockInfo.blockedbyname}</span>
                              </span>
                           </div>
                        </div>
                     </div>
                  )}
               </ModalHeader>
               <ModalBody className="px-6 py-6">
                  {/* Enhanced Tabs */}
                  <div className={`flex space-x-2 p-1 rounded-lg mb-6 ${isDark ? 'bg-slate-800' : 'bg-gray-100'}`}>
                     <button
                        onClick={() => setActiveTab('information')}
                        className={`
                  flex-1 px-4 py-2.5 rounded-md text-sm font-medium transition-all duration-200
                  ${
                     activeTab === 'information'
                        ? isDark
                           ? 'bg-blue-600 text-white shadow-lg'
                           : 'bg-white text-blue-600 shadow-sm'
                        : isDark
                        ? 'text-gray-400 hover:text-white hover:bg-slate-700'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }
               `}>
                        Information
                     </button>
                     {isCustomersOrVendors && (
                        <button
                           onClick={() => setActiveTab('payment')}
                           className={`
                     flex-1 px-4 py-2.5 rounded-md text-sm font-medium transition-all duration-200
                     ${
                        activeTab === 'payment'
                           ? isDark
                              ? 'bg-blue-600 text-white shadow-lg'
                              : 'bg-white text-blue-600 shadow-sm'
                           : isDark
                           ? 'text-gray-400 hover:text-white hover:bg-slate-700'
                           : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                     }
                  `}>
                           Outstanding
                        </button>
                     )}
                     <button
                        onClick={() => setActiveTab('statement')}
                        className={`
                  flex-1 px-4 py-2.5 rounded-md text-sm font-medium transition-all duration-200
                  ${
                     activeTab === 'statement'
                        ? isDark
                           ? 'bg-blue-600 text-white shadow-lg'
                           : 'bg-white text-blue-600 shadow-sm'
                        : isDark
                        ? 'text-gray-400 hover:text-white hover:bg-slate-700'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }
               `}>
                        Statement
                     </button>
                  </div>

                  {/* Content Area */}
                  <div className="min-h-[400px]">
                     {activeTab === 'information' && renderInfoTab()}
                     {activeTab === 'payment' && isCustomersOrVendors && renderPaymentTab()}
                     {activeTab === 'statement' &&
                        (entityType === 'item' ? renderStatementTabForItem() : renderStatementTab())}
                  </div>
               </ModalBody>

               {/* Enhanced Footer */}
               <div
                  className={`
         px-6 py-4 border-t
         ${isDark ? 'border-slate-700 bg-slate-800/50' : 'border-gray-200 bg-gray-50'}
         rounded-b-xl
      `}>
                  <div className="flex justify-end space-x-3">
                     {activeTab !== 'statement' && (
                        <button
                           onClick={() => setActiveTab('statement')}
                           className={`
                     px-5 py-2 rounded-lg font-medium text-sm transition-all duration-200
                     ${isDark ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-blue-600 hover:bg-blue-700 text-white'}
                  `}>
                           View Statement
                        </button>
                     )}
                     <button
                        onClick={onClose}
                        className={`
                  px-5 py-2 rounded-lg font-medium text-sm transition-all duration-200
                  ${
                     isDark
                        ? 'bg-slate-700 hover:bg-slate-600 text-white'
                        : 'bg-gray-200 hover:bg-gray-300 text-gray-700'
                  }
               `}>
                        Cancel
                     </button>
                  </div>
               </div>
               {updateFormLoading && formData.id && (
                  <PaymentcaseFormEdit
                     isOutstandingModalOpen={isOutstandingModalOpen}
                     setIsOutstandingModalOpen={setIsOutstandingModalOpen}
                     daybookTypeData={daybookTypeData}
                     validationSchema={validationSchema}
                     errors={errors}
                     setErrors={setErrors}
                     selectedAccount={selectedEditAccount}
                     setSelectedAccount={setSelectedEditAccount}
                     userData={accountData}
                     type={13}
                     isEditMode={true}
                     receivedAmount={receivedAmount}
                     setReceivedAmount={setReceivedAmount}
                     totalPendingAccount={totalPendingAccount}
                     setTotalPendingAccount={setTotalPendingAccount}
                     formData={formData}
                     setFormData={setFormData}
                     transactionType={transactionType}
                     handleClearData={handleClearData}
                     pendingVoucher={pendingVoucher}
                     setPendingVoucher={setPendingVoucher}
                     currentPage={1}
                     limit={10}
                     companyId={companyId}
                     sorting={sorting}
                     pagination={10}
                  />
               )}
            </ModalContent>
         </Modal>
         {(formType === 'Customer' || formType === 'Vendor') && (
            <AddEditForm
               isOpen={isOpen}
               onClose={handleClose}
               isEditMode={isEditMode}
               currentRow={singleEntity}
               initialData={singleEntity}
               parentGlGroup={parentGlGroup}
               formType={formType}
            />
         )}
         {formType === 'Item' && (
            <ItemMasterForm isOpen={isOpen} onClose={handleClose} isEditMode={isEditMode} currentRow={singleEntity} />
         )}
         {formType === 'Account' && (
            <AddEditFormForAccount
               isOpen={isOpen}
               onClose={handleClose}
               isEditMode={isEditMode}
               currentRow={singleEntity}
               initialData={singleEntity}
               formType={formType}
            />
         )}
         {formType === 'daybook' && (
            <DaybookForm isOpen={isOpen} onClose={handleClose} isEditMode={isEditMode} currentRow={singleEntity} />
         )}
         <DeleteDialog
            isDeleteDialogOpen={isDeleteDialogOpen}
            setDeleteDialogOpen={setDeleteDialogOpen}
            handleDelete={handleDelete}
            title={formType}
         />

         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            title={
               entityTypesv === 'saleinvoice'
                  ? 'Sales Invoice'
                  : entityTypesv === 'salereturn'
                  ? 'Sales Return'
                  : entityTypesv === 'purchaseinvoice'
                  ? 'Purchase Invoice'
                  : entityTypesv === 'receiveinventory'
                  ? 'Receive Inventory'
                  : entityTypesv === 'issueinventory'
                  ? 'Issue Inventory'
                  : 'Purchase Return'
            }
            entityType={entityTypesv}
            singleEntity={viewDetail}
            setIsEditFormOpen={setIsEditFormOpen}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            // billTerms={viewDetail?.purchasereturnbillteams}
            billTerms={
               entityTypesv === 'saleinvoice'
                  ? viewDetail?.salebillterms
                  : entityTypesv === 'salereturn'
                  ? viewDetail?.salebillterms
                  : entityTypesv === 'purchaseinvoice'
                  ? viewDetail?.purchasebillteams
                  : entityTypesv === 'receiveinventory'
                  ? viewDetail?.receiveLineDetail
                  : entityTypesv === 'issueinventory'
                  ? viewDetail?.issueLineDetail
                  : viewDetail?.purchasereturnbillteams
            }
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => {
               console.log('');
            }}
         />

         <SalesSingleDataView
            isOpenSingleView={isOpenSingleViewinr}
            onClose={handleSalesSingleDataViewClose}
            entityType={entityTypesv}
            singleEntity={singleEntitysv}
            dynamicUserDetails={dynamicUserDetails}
            onEditFormClose={() => setIsOpenSingleViewinr(true)}
            setIsOpenSingleView={setIsOpenSingleViewinr}
            isEditFormOpen={isEditFormOpen}
            setIsEditFormOpen={setIsEditFormOpen}
            title={entityTypesv === 'issuemaster' ? 'Issue' : 'Receive'}
            handleViewSingleData={handleViewSingleData}
         />

         <ViewSingleCashBankData
            isOpenSingleView={isOpenSingleViewcnb}
            onClose={() => setIsOpenSingleViewcnb(false)}
            singleEntity={singleEntitysv}
            formType="voucher"
            isBankPageTrue={isBankPageTrue}
            UserRights={cashRight}
            startEditing={(data) => startEditing(data.id, data)}
         />

         <JournalVoucherForm
            isOpen={isOpenJV}
            onClose={() => setisOpenJV(false)}
            isEditMode={isEditMode}
            currentRow={currentRow}
            onSave={handleSave}
         />
      </>
   );
};

export default ViewSingleData;
